import React from 'react';

/**
 * Monta um template de relatório fora da tela enquanto o PDF é gerado. O
 * html2canvas precisa do elemento no DOM, mas o usuário não deve vê-lo.
 */
const HiddenReport = ({ children }) => (
  <div style={{ position: 'absolute', left: '-9999px', top: 0 }} aria-hidden="true">
    {children}
  </div>
);

export default HiddenReport;
